import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import ProductHero from '../components/product/ProductHero';
import WorkflowDiagram from '../components/product/WorkflowDiagram';
import WorkflowGrid from '../components/product/WorkflowGrid';
import TrustStrip from '../components/product/TrustStrip';
import styles from './ProductPage.module.css';

// Public "Product" page - the workflows. Reuses the marketing nav/footer and owns
// its own scroll container (global `body { overflow: hidden }` for the app shell).
export default function ProductPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <ProductHero />
        <WorkflowDiagram />
        <WorkflowGrid />
        <TrustStrip />
      </main>
      <LandingFooter />
    </div>
  );
}
